import React, { Component } from "react";
import { Modal, Card, Row, Col } from "react-bootstrap";
import "../styling/Styles.css";
import { Typography, Button } from "@material-ui/core";
import { Label, Alert } from "reactstrap";

import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";

import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import PrintIcon from "@material-ui/icons/Print";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { Fab, IconButton, Snackbar } from "@material-ui/core";
import ReactToPrint from "react-to-print";
import ModifierReg from "./ModifierReglement";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const actions = [
  // { icon: <PrintIcon />, name: "Imprimer" },
  { icon: <EditIcon />, name: "Modifier" },
  { icon: <DeleteOutlineIcon />, name: "Supprimer" },
];

const DATE_OPTIONS = {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric",
};

const DATE_OPTIONSS = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

var curr = new Date();
curr.setDate(curr.getDate());
var date = curr.toISOString().substr(0, 10);

class GetReglementByIdModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      popoverOpen: false,
      anchorEl: null,
      snackbaropen: false,
      snackbarmsg: "",
      fournisseurimp: [],
      todaydate: date,
      openModifierModal: false,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClosee = () => {
    this.setState({ anchorEl: null });
  };

  toggle = () => {
    this.setState({ popoverOpen: true });
  };

  handleOpen = () => {
    this.setState({ open: true });
    fetch(
      `https://www.24-crm.tn/webservice/api/Fournisseurs?codefournisseur=${this.props.fournisseur}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => this.setState({ fournisseurimp: data }));
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  snackbarClose = (event) => {
    this.setState({ snackbaropen: false });
  };

  supprimer = () => {
    if (
      window.confirm(
        `êtes-vous sûr de vouloir supprimer Le réglement numéro ${this.props.regid}?`
      )
    ) {
      
      fetch(
        `https://www.24-crm.tn/webservice/api/LigREGFRS/${this.props.regid}?coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
        {
          method: "DELETE",
          header: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        fetch(
          `https://www.24-crm.tn/webservice/api/REGFRs/${this.props.regid}?coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
          {
            method: "DELETE",
            header: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((result) => {
            this.props.onHide();
            fetch(
              `https://www.24-crm.tn/webservice/api/FOURNISSEURs?Codfrssss=${this.props.fournisseur}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
              {
                method: "POST",
                header: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }
            );
            this.setState({ snackbaropen: true, snackbarmsg: result });

            window.location.reload();
          });
      });
    }
  };

  openModifier = () => {
    this.setState({ openModifierModal: true });
  };

  render() {
    let ModifierModalClose = () => this.setState({ openModifierModal: false });

    const { darck } = this.props;

    const openn = Boolean(this.state.anchorEl);
    const id = openn ? "simple-popover" : undefined;
    return (
      <div className="container">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={this.state.snackbaropen}
          autoHideDuration={2000}
          onClose={this.snackbarClose}
          message={<span id="message-id"> {this.state.snackbarmsg} </span>}
          action={[
            <IconButton
              key="close"
              color="inherit"
              onClick={this.snackbarClose}
            >
              x
            </IconButton>,
          ]}
        ></Snackbar>

        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: `${darck ? "#fff" : "#172431"}`,
              color: `${darck ? "#020F64" : "#fff"}`,
              borderTop: `${darck ? "" : "2px solid #fff"}`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              borderBottom: `none`,
            }}
          >
            <Modal.Title id="contained-modal-title-vcenter">
              <b>Détails Règlement Fournisseur</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
                      style={{
                        backgroundColor: `${darck ? "#fff" : "#172431"}`,
                        border: `${darck ? "" : "2px solid #fff"}`,
                        borderBottom: `none`,
                      }}
          >
            <Card>
              <Card.Body
                              style={{
                                backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                border: `${darck ? "" : "2px solid #fff"}`,
                              }}
              >
                <Row>
                  <Col style={{ textAlign: "center" }} sm={3}>
                    <Typography variant="h6" component="h2">
                      <Label style={{ color: `${darck ? "#020f64" : "#fff"}` }}>№ Règlement</Label>
                    </Typography>
                    <Typography style={{ color: `${darck ? "#grey" : "#fff"}`, fontSize: "14px" }}>
                      {this.props.regid}
                    </Typography>
                  </Col>

                  <Col style={{ textAlign: "center" }} sm={3}>
                    <Typography variant="h6" component="h2">
                      <Label style={{ color: `${darck ? "#020f64" : "#fff"}` }}>Date Règ</Label>
                    </Typography>
                    <Typography style={{ color: `${darck ? "#grey" : "#fff"}`, fontSize: "14px" }}>
                      {/* {this.props.datebl} */}
                      {new Date(this.props.datereg).toLocaleDateString(
                        "fr",
                        DATE_OPTIONS
                      )}
                    </Typography>
                  </Col>

                  <Col style={{ textAlign: "center" }} sm={2}>
                    <Typography variant="h6" component="h2">
                      <Label style={{ color: `${darck ? "#020f64" : "#fff"}` }}>Fournisseur</Label>
                    </Typography>
                    <Typography style={{ color: `${darck ? "#grey" : "#fff"}`, fontSize: "14px" }}>
                      {this.props.fournisseur}
                    </Typography>
                  </Col>

                  <Col style={{ textAlign: "center" }} sm={4}>
                    <Typography variant="h6" component="h2">
                      <Label style={{ color: `${darck ? "#020f64" : "#fff"}` }}>Raison Sociale</Label>
                    </Typography>
                    <Typography style={{ color: `${darck ? "#grey" : "#fff"}`, fontSize: "14px" }}>
                      {this.props.raisonsociale}
                    </Typography>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <br />

            <Row>
              <Col sm={6}>
                <Card>
                  <Card.Body
                                  style={{
                                    backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                    border: `${darck ? "" : "2px solid #fff"}`,
                                  }}
                  >
                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={6}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>Mode règlement</p>
                      </Col>
                      <Col sm={6}>
                        {this.props.modreg === "" ||
                        this.props.modreg === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.modreg}</p>
                        )}
                      </Col>
                    </Row>

                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={6}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>№ Pièce</p>
                      </Col>

                      <Col sm={6}>
                        {this.props.numchq === "" ||
                        this.props.numchq === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.numchq}</p>
                        )}
                      </Col>
                    </Row>

                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={6}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>
                          Banque fournisseur
                        </p>
                      </Col>

                      <Col sm={6}>
                        {this.props.matban === "" ||
                        this.props.matban === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.matban}</p>
                        )}
                      </Col>
                    </Row>

                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={6}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>Agence</p>
                      </Col>

                      <Col sm={6}>
                        {this.props.agence === "" ||
                        this.props.agence === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.agence}</p>
                        )}
                      </Col>
                    </Row>

                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={6}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>Caisse</p>
                      </Col>

                      <Col sm={6}>
                        {this.props.numcais === "" ||
                        this.props.numcais === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.numcais}</p>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={6}>
                <Card style={{ height: "100%" }}>
                  <Card.Body
                                  style={{
                                    backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                    border: `${darck ? "" : "2px solid #fff"}`,
                                  }}
                  >
                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={7}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>Echéance</p>
                      </Col>

                      <Col sm={5}>
                        {this.props.datech === null ||
                        this.props.datech === "" ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>
                            {" "}
                            {new Date(this.props.datech).toLocaleDateString(
                              "fr",
                              DATE_OPTIONSS
                            )}
                          </p>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={7}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>Titulaire</p>
                      </Col>

                      <Col sm={5}>
                        {this.props.titulaire === "" ||
                        this.props.titulaire === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>
                            {this.props.titulaire}
                          </p>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={7}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>Situation</p>
                      </Col>

                      <Col sm={5}>
                        {this.props.verser === "" ||
                        this.props.verser === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.verser}</p>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={7}>
                        <p style={{ color: `${darck ? "#darkslateblue" : "#fff"}` }}>
                          Banque versement
                        </p>
                      </Col>

                      <Col sm={5}>
                        {this.props.bqescompte === "" ||
                        this.props.bqescompte === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>
                            {this.props.bqescompte}
                          </p>
                        )}
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "-12px" }}>
                      <Col sm={7}>
                        <p style={{color: `${darck ? "#darkslateblue" : "#fff"}` }}>C.C.B</p>
                      </Col>

                      <Col sm={5}>
                        {this.props.codccb === "" ||
                        this.props.codccb === null ? (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>--</p>
                        ) : (
                          <p style={{ color: `${darck ? "#black" : "#fff"}` }}>{this.props.codccb}</p>
                        )}
                      </Col>
                    </Row>{" "}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <br />
            <Card>
              <Card.Body
                                  style={{
                                    backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                    border: `${darck ? "" : "2px solid #fff"}`,
                                  }}
              >
                <Row>
                  <h5 style={{ color: `${darck ? "" : "#fff"}` }}>Détails</h5>
                  <div className="tabftre">
                    <table>
                      <thead>
                        <tr>
                          <th>N°Facture_Frs</th>
                          <th>Type</th>

                          <th>Montant</th>
                          <th>Reg.Ant</th>
                          <th>Montant.Reg</th>
                          <th>Reste</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: `${darck ? "" : "#fff"}` }}>
                        {this.props.detailAffectation.map((el) => (
                          <tr>
                            <td>{el.numfacfrs}</td>
                            <td>{el.typfac}</td>
                            <td>{el.montfac.toFixed(3)}</td>
                            <td>
                              {Number(
                                Math.abs(el.montfac - el.montant - el.reste)
                              ).toFixed(3)}
                            </td>

                            <td>{el.montant.toFixed(3)}</td>
                            <td>{el.reste.toFixed(3)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Row>
              </Card.Body>
            </Card>

            <Card style={{ marginTop: "12px" }}>
              <Card.Body
                              style={{
                                backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                border: `${darck ? "" : "2px solid #fff"}`,
                              }}
              >
                <Row style={{ marginBottom: "-12px" }}>
                  <Col sm={3}>
                    <div>
                      <Button
                        aria-describedby={id}
                        variant="contained"
                        color="primary"
                        style={{
                          //  background: "#17a2b8",
                          width: "100%",
                          height: "60px",
                        }}
                        onClick={this.handleClick}
                      >
                        Note
                      </Button>
                      <Popover
                        id={id}
                        open={openn}
                        anchorEl={this.state.anchorEl}
                        onClose={this.handleClosee}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <Typography
                          style={{
                            width: "500px",
                            height: "100px",
                            padding: "10px",
                            background: "#eee",
                          }}
                          className={useStyles.typography}
                        >
                          {this.props.note === "" ||
                          this.props.note === null ? (
                            <p style={{ color: `${darck ? "#172431" : "#fff"}` }}> Note Vide ... </p>
                          ) : (
                            <p                               
                            style={{
                              color: `${darck ? "#172431" : "#fff"}`,
                              fontSize: "17px",
                            }}>
                              {this.props.note}
                            </p>
                          )}
                        </Typography>
                      </Popover>
                    </div>
                    {/* {this.props.note === "" ||
                    this.props.note === null ? null : (
                      <div>
                        <Row>
                          <Col sm={3}>
                            <p style={{ color: "#17a2b8" }}>Note</p>
                          </Col>
                          <Col sm={9}>
                            <p style={{ color: "black", fontSize: "12px" }}>
                              {this.props.note}
                            </p>
                          </Col>
                        </Row>
                      </div>
                    )} */}
                  </Col>
                  <Col sm={8}>
                    <Alert
                      color={"secondary"}
                      style={{
                        width: "100%",
                        height: "60px",
                      }}
                    >
                      <h4 style={{ color: "#17a2b8", textAlign: "center" }}>
                        Montant &nbsp;&nbsp;
                        <span style={{ color: `${darck ? "" : "#black"}` }}>
                          {Number(this.props.monreg).toFixed(3)}
                        </span>
                      </h4>
                    </Alert>
                  </Col>

                  {/* <Col sm={5}></Col> */}
                  <Col sm={1}>
                    <div>
                      <SpeedDial
                        style={{
                          position: "absolute",
                          bottom: "25px",
                          right: "0px",
                        }}
                        ariaLabel="SpeedDial openIcon example"
                        hidden={this.state.hidden}
                        icon={<EditIcon openIcon={<EditIcon />} />}
                        onClose={this.handleClose}
                        onOpen={this.handleOpen}
                        open={this.state.open}
                        FabProps={{ size: "small" }}
                      >
                        {actions.map((action) => (
                          <SpeedDialAction
                            key={action.name}
                            icon={action.icon}
                            tooltipTitle={action.name}
                            onClick={() => {
                              this.handleClose();
                              action.name === "Modifier" && this.openModifier();
                              action.name === "Supprimer" && this.supprimer();
                            }}
                          />
                        ))}
                        {!this.state.open ? (
                          <ReactToPrint
                            trigger={() => (
                              <Fab
                                size="small"
                                style={{
                                  backgroundColor: "white",
                                  display: "none",
                                }}
                                aria-label="add"
                              >
                                <PrintIcon />
                              </Fab>
                            )}
                            content={() =>
                              this.props.modreg.toUpperCase().includes("RS")
                                ? this.componentRefretenu
                                : this.componentRef
                            }
                          />
                        ) : (
                          <ReactToPrint
                            trigger={() => (
                              <Fab
                                size="small"
                                style={{
                                  backgroundColor: "white",
                                  marginLeft: "7px",
                                  color: "grey",
                                }}
                                aria-label="add"
                              >
                                <PrintIcon />
                              </Fab>
                            )}
                            content={() =>
                              this.props.modreg.toUpperCase().includes("RS")
                                ? this.componentRefretenu
                                : this.componentRef
                            }
                          />
                        )}
                      </SpeedDial>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Modal.Body>
          {/* <Modal.Footer></Modal.Footer> */}

          <ModifierReg
            show={this.state.openModifierModal}
            onHide={ModifierModalClose}
            regid={this.props.regid}
            raisonsocial={this.props.raisonsociale}
            codefournisseur={this.props.fournisseur}
            datreg={this.props.datereg}
            codmodreg={this.props.modreg}
            soldfacbl={this.props.soldfacbl}
            // libmodreg={this.props.}
            bqfournisseur={this.props.matban}
            montant={this.props.monreg}
            codbqfournisseur={this.props.matban}
            // libbqfournisseur={this.props.}
            codagence={this.props.agence}
            // libagence={this.props.}
            codcaisse={this.props.numcais}
            // libcaisse={this.props.}
            codsituation={this.props.verser}
            // libsituation={this.props.}
            codbqvers={this.props.bqescompte}
            // libbqvers={this.props.}
            codccb={this.props.codccb}
            titulaire={this.props.titulaire}
            datech={this.props.datech}
            numchq={this.props.numchq}
            note={this.props.note}
            detailAffectation={this.props.detailAffectation}
            // libccb={this.props.}
            // chdec={this.props.}
          />
        </Modal>
        {/* ///////////////// Imprimer un Retenu à la source  /////////// */}
        <div style={{ display: "none" }}>
          <div
            ref={(el) => (this.componentRefretenu = el)}
            style={{ margin: "50px", marginTop: "100px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              <p>
                REPUBLIQUE TUNISIENNE <br /> MINISTERE DU PLAN ET DES FINANCES{" "}
                <br /> DIRECTION GENERALE DU CONTROLE FISCALE
              </p>
              <p>
                CERTIFICAT DE RETENU D'IMPOT <br /> SUR LE REVENU <br /> OU
                D'IMPOT SUR LES SOCIETES
              </p>
            </div>
            <h4 style={{ float: "right", marginTop: "10px" }}>
              Le:{" "}
              {new Date(this.state.todaydate).toLocaleDateString(
                "fr",
                DATE_OPTIONSS
              )}
            </h4>

            <div
              style={{
                border: "solid 1px black",
                marginTop: "40px",
                padding: "20px",
              }}
            >
              <h4
                style={{
                  width: "100%",

                  marginTop: "20px",
                }}
              >
                A- PERSONNE OU ORGANISME PAYEUR:&nbsp;&nbsp;
              </h4>
              <div
                style={{
                  float: "right",
                  fontSize: "13px",
                  marginBottom: "20px",
                }}
              >
                <h3>Identifiant</h3>
                <table border="1" style={{ height: "80px" }}>
                  <thead>
                    <th>
                      Matricule <br /> Fiscale
                    </th>
                    <th>Code TVA</th>
                    <th>Code Catégorie (2)</th>
                    <th>
                      N° Etab.
                      <br />
                      secondaire
                    </th>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    <td>
                      {this.props.InfoEntreprise[0].codtva.split("/")[0]}{" "}
                    </td>
                    <td>{this.props.InfoEntreprise[0].codtva.split("/")[1]}</td>
                    <td>
                      {this.props.InfoEntreprise[0].codtva.split("/")[2]}{" "}
                    </td>
                    <td>
                      {this.props.InfoEntreprise[0].codtva.split("/")[3]}{" "}
                    </td>
                  </tbody>
                </table>
              </div>

              {/* <div style={{ borderBottomStyle: "solid" }}> */}
              {/* <div>
                <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                  Fournisseur : &nbsp;&nbsp;{" "}
                  <span className="imp">
                    <b>{this.props.fournisseur}</b> {this.props.raisonsociale}
                  </span>
                </h2>

                <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                  Règlement : &nbsp;&nbsp;{" "}
                  <span className="imp">{this.props.modreg}</span>
                </h2>

                {this.props.numchq === "" ||
                this.props.numchq === null ? null : (
                  <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                    Pièce : &nbsp;&nbsp;{" "}
                    <span className="imp">
                      {this.props.numchq} &nbsp; <b>Au</b>{" "}
                      {new Date(this.props.datech).toLocaleDateString(
                        "fr",
                        DATE_OPTIONSS
                      )}
                      &nbsp; <b>Banque</b> &nbsp;
                      {this.props.matban}
                    </span>
                  </h2>
                )}

                <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                  Montant : &nbsp;&nbsp;{" "}
                  <span className="imp">
                    {Number(this.props.monreg).toFixed(3)}
                  </span>
                </h2>

                <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                  Date du règlement : &nbsp;&nbsp;{" "}
                  <span className="imp">
                    {new Date(this.props.datereg).toLocaleDateString(
                      "fr",
                      DATE_OPTIONSS
                    )}
                  </span>
                </h2>
              </div> */}
              <br />
              <div>
                <div>
                  Dénomination de la personne ou de l'organisme payeur:{" "}
                </div>
                <div>Adresse: </div>
                <table border="1" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>B- RETENUS EFFECTUEES SUR : </th>
                      <td>MONTANT BRUT</td>
                      <th>RETENU </th>

                      <th>MONTANT NET</th>
                    </tr>
                  </thead>
                  <tbody>
                    <td rowSpan={this.props.detailAffectation.length + 2}>
                      {" "}
                      FACTURE N°:{" "}
                      {this.props.detailAffectation.map((el) => (
                        <span>
                          {el.numfacfrs} <br />
                        </span>
                      ))}
                      <div style={{ bottom: "0", fontWeight: "bold" }}>
                        {" "}
                        Total
                      </div>
                    </td>

                    {this.props.detailAffectation.map((el) => (
                      <tr>
                        <td>{el.montfac.toFixed(3)}</td>
                        <td>{el.montant.toFixed(3)}</td>
                        <td>{(el.montfac - el.montant).toFixed(3)}</td>
                      </tr>
                    ))}

                    <tr>
                      <td>
                        {this.props.detailAffectation
                          .reduce((c, v) => c + v.montfac, 0)
                          .toFixed(3)}{" "}
                      </td>

                      <td>
                        {this.props.detailAffectation
                          .reduce((c, v) => c + v.montant, 0)
                          .toFixed(3)}{" "}
                      </td>
                      <td>
                        {this.props.detailAffectation
                          .reduce((c, v) => c + (v.montfac - v.montant), 0)
                          .toFixed(3)}{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <h4>C- BENIFICIERE</h4>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex" }}>
                  <p>
                    Numéro de la CIN ou <br />
                    de la carte de Séjour pour les étrangers
                  </p>
                  <div
                    style={{
                      height: "20px",
                      width: "100px",
                      border: "1px solid black ",
                    }}
                  >
                    {" "}
                  </div>
                </div>
                <div
                  style={{
                    float: "right",
                    fontSize: "13px",
                  }}
                >
                  <h3>Identifiant</h3>
                  <table
                    border="1"
                    style={{ textAlign: "center", height: "80px" }}
                  >
                    <thead>
                      <th>
                        Matricule <br /> Fiscale
                      </th>
                      <th>Code TVA</th>
                      <th>Code Catégorie (2)</th>
                      <th>
                        N° Etab.
                        <br />
                        secondaire
                      </th>
                    </thead>
                    <tbody>
                      <td>{this.props.matricule} </td>
                      <td>{this.props.codtva}</td>
                      <td> {this.props.categorie}</td>
                      <td>{this.props.ntab} </td>
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                Nom , Prénom ou Raison Sociale: {this.props.raisonsociale}
              </div>
              <div>Adresse Professionelle: {this.props.adresse}</div>
              <div>Adresse de Résidence:</div>

              {/* //////////////////////// footer ///////////////////////////// */}
              <div
                style={{
                  borderTop: "1px solid black",
                  width: "100%",

                  textAlign: "center",
                  marginTop: "50px",
                  fontSize: "14px",
                  marginLeft: "5px",
                }}
              >
                <p>
                  Je sousigné,certifie exacts les renseignements figurant sur le
                  présent certificat
                  <br /> et m'expose aux sanctions prévus par la loi pour toute
                  inexactitude{" "}
                </p>
                <h5
                  style={{
                    float: "right",
                    marginRight: "50px",
                  }}
                >
                  {" "}
                  Signature & Cachet{" "}
                </h5>
                {/* <h3 style={{ marginRight: "200px" }}>
                  {" "}
                  Signature Fournisseur{" "}
                </h3> */}
              </div>
              <div style={{ height: "200px" }}></div>
              {/* <br />
              <br />
              <br />
              <br />
              <br />
              <br /> */}
            </div>
            <div style={{ marginTop: "20px" }}>
              <p>
                (1): le certificat est délivré à l'occasion de chaque payement
                toutefois pour les opérations répétitives le certificat peut
                être délivré trimestriellement{" "}
              </p>
              <p>
                (2): Code catégories: M.personne morale- C.personne
                physiqye-industries et commerce- P.professions libérales-
                N.employeur non soumis à l'impôt sur le revenu ou sur les
                sociétés (administrations et établissements publics)-
                E.établissements secondaires{" "}
              </p>
            </div>
          </div>
        </div>
        {/* ///////////////// Imprimer  /////////// */}
        <div style={{ display: "none" }}>
          <div
            ref={(el) => (this.componentRef = el)}
            style={{ margin: "15px", height: "98%" }}
          >
            <h1 style={{ fontSize: "50px", fontWeight: "bolder" }}>
               {this.props.InfoEntreprise[0].coddos}
            </h1>
            <p style={{ fontSize: "20px", marginTop: "-10px" }}>
              {this.props.InfoEntreprise[0].spe}
              <br />
              Adresse : {this.props.InfoEntreprise[0].adr} <br />
              Tél:{this.props.InfoEntreprise[0].tel1} / Gsm:{" "}
              {this.props.InfoEntreprise[0].tel2} / Email:{" "}
              {this.props.InfoEntreprise[0].email} <br />
              Maricule Fiscale   :   {this.props.InfoEntreprise[0].codtva} <br />
              RIB: {this.props.InfoEntreprise[0].rib}{" "}
              {this.props.InfoEntreprise[0].matban}
              {this.props.InfoEntreprise[0].agence}{" "}
              {this.props.InfoEntreprise[0].ville}
              <br />
              Etabli par: {this.props.Auth.username}
            </p>
            <div
              style={{ borderTopStyle: "solid", marginBottom: "20px" }}
            ></div>
            <h1
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              Ordre de payement №: {this.props.regid}{" "}
            </h1>
            <Row>
              <Col></Col>
              <Col>
                <h4 style={{ marginLeft: "230px" }}>
                  Le:{" "}
                  {new Date(this.state.todaydate).toLocaleDateString(
                    "fr",
                    DATE_OPTIONSS
                  )}
                </h4>

                {/* {this.state.fournisseurimp.map((t) =>
                  t.codtva === "" ? (
                    <h6>Code TVA : --</h6>
                  ) : (
                    <h6>Code TVA : {t.codtva}</h6>
                  )
                )} */}
              </Col>
            </Row>
            <br />

            <br />

            {/* <div style={{ borderBottomStyle: "solid" }}> */}
            <div>
              <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                Fournisseur : &nbsp;&nbsp;{" "}
                <span className="imp">
                  <b>{this.props.fournisseur}</b> {this.props.raisonsociale}
                </span>
              </h2>

              <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                Règlement : &nbsp;&nbsp;{" "}
                <span className="imp">{this.props.modreg}</span>
              </h2>

              {this.props.numchq === "" || this.props.numchq === null ? null : (
                <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                  Pièce : &nbsp;&nbsp;{" "}
                  <span className="imp">
                    {this.props.numchq} &nbsp; <b>Au</b>{" "}
                    {new Date(this.props.datech).toLocaleDateString(
                      "fr",
                      DATE_OPTIONSS
                    )}
                    &nbsp; <b>Banque</b> &nbsp;
                    {this.props.matban}
                  </span>
                </h2>
              )}

              <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                Montant : &nbsp;&nbsp;{" "}
                <span className="imp">
                  {Number(this.props.monreg).toFixed(3)}
                </span>
              </h2>

              <h2 style={{ marginBottom: "15px", marginLeft: "10px" }}>
                Date du règlement : &nbsp;&nbsp;{" "}
                <span className="imp">
                  {new Date(this.props.datereg).toLocaleDateString(
                    "fr",
                    DATE_OPTIONSS
                  )}
                </span>
              </h2>
            </div>
            {/* <table border="1" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Numéro</th>
                  <th>Type</th>

                  <th>Montant</th>
                  <th>Reg.Ant</th>
                  <th>Montant.Reg</th>
                  <th>Reste</th>
                </tr>
              </thead>
              <tbody>
                {this.props.detailAffectation.map((el) => (
                  <tr>
                    <td>{el.numfacfrs}</td>
                    <td>{el.typfac}</td>
                    <td>{el.montfac.toFixed(3)}</td>
                    <td>
                      {Number(
                        Math.abs(el.montfac - el.montant - el.reste)
                      ).toFixed(3)}
                    </td>

                    <td>{el.montant.toFixed(3)}</td>
                    <td>{el.reste.toFixed(3)}</td>
                  </tr>
                ))}
              </tbody>
            </table> */}
            <br />
            {/* //////////////////////// footer ///////////////////////////// */}
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                textAlign: "center",
                marginTop: "20px",
                justifyContent: "space-between",
                marginLeft: "5px",
              }}
            >
              <h3 style={{ marginLeft: "170px" }}> Signature & Cachet </h3>
              <h3 style={{ marginRight: "200px" }}> Signature Fournisseur </h3>
            </div>

            <br />
            <br />
            <br />
            <div style={{ borderBottomStyle: "dashed" }}></div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ConfigDossier: state.ConfigDossier,
    InfoEntreprise: state.InfoDossier,
    Auth: state.Auth,
    darck: state.darck.darck,
  };
}
export default connect(mapStateToProps, null)(GetReglementByIdModal);
